import { IS_MAC } from "#app/lib/platform";
import { useHotkey } from "./use-hotkey";

/** Keycaps for the chord that saves the current view's unsaved edits. The
 *  Save button's tooltip advertises it and the shortcuts reference derives
 *  its row from it. The binding fires on metaKey OR ctrlKey, so both labels
 *  are true; Enter is the return glyph on every platform. */
export const SAVE_VIEW_SHORTCUT: readonly string[] = IS_MAC
  ? ["⌘", "↵"]
  : ["Ctrl", "↵"];

/**
 * ⌘/Ctrl+Enter commits the view's draft — the same act as pressing its Save
 * button. `save` is null while there is nothing the viewer can save (no
 * draft, no permission, a save in flight), and the chord is detached then:
 * it is owned by the button's presence, so it can never commit a view whose
 * Save the viewer could not have clicked.
 *
 * Editors keep the chord: ⌘Enter posts a comment in a rich-text field and
 * the view must not save under it. A modal dialog owns the keys while open.
 * Enter is gated on the physical key so the numeric keypad's return counts.
 */
export function useSaveViewHotkey(save: (() => void) | null): void {
  useHotkey({
    code: ["Enter", "NumpadEnter"],
    mod: true,
    enabled: save !== null,
    handler: () => save?.(),
  });
}
